import { DEMO_DATE, WEEK_ID, WEEK_START } from '../data/demo';
import { TaskTemplate } from '../types/family';
import { DutyCheck, DutySlot } from '../types/shared';
import { addDays } from './time';

export const dutySlots: { slot: DutySlot; short: string; label: string; date: string }[] = [
  { slot: 'pon', short: 'Pon', label: 'do konca ponedeljka', date: addDays(WEEK_START, 0) },
  { slot: 'sre', short: 'Sre', label: 'do konca srede', date: addDays(WEEK_START, 2) },
  { slot: 'sob', short: 'Sob', label: 'do konca sobote', date: addDays(WEEK_START, 5) },
];

export type SlotState = 'urejeno' | 'popravljeno' | 'ni-urejeno' | 'odprto' | 'izpadlo';

export const slotStateLabels: Record<SlotState, string> = {
  urejeno: 'urejeno',
  popravljeno: 'popravljeno',
  'ni-urejeno': 'ni urejeno',
  odprto: 'še ni pregledano',
  izpadlo: 'pregleda ni bilo – se ne šteje',
};

/** Tedenska zadolžitev: hišna kategorija ali soba – skrb ves teden, ne enkratna kljukica. */
export function isDuty(t: TaskTemplate): boolean {
  return t.group === 'hisa' && t.valueType === 'osnovno' && t.frequency?.kind === 'tedensko';
}

export function dutyChecksFor(checks: DutyCheck[], familyId: string, templateId: string): DutyCheck[] {
  return checks.filter((c) => c.familyId === familyId && c.weekId === WEEK_ID && c.templateId === templateId);
}

export function slotState(check: DutyCheck | undefined, date: string): SlotState {
  if (check) return check.result === 'urejeno' ? 'urejeno' : check.fixed ? 'popravljeno' : 'ni-urejeno';
  return date < DEMO_DATE ? 'izpadlo' : 'odprto';
}

export function currentSlot(): DutySlot {
  return (dutySlots.find((s) => s.date >= DEMO_DATE) ?? dutySlots[dutySlots.length - 1]).slot;
}

/** Točke po deležu urejenih pregledov. Pregled, ki ga starš ni opravil do roka, izpade in otroku ne vzame točk. */
export function dutyScore(value: number, checks: DutyCheck[]) {
  const states = dutySlots.map((s) => slotState(checks.find((c) => c.slot === s.slot), s.date));
  const counted = states.filter((s) => s !== 'izpadlo').length;
  const tidy = states.filter((s) => s === 'urejeno' || s === 'popravljeno').length;
  const checked = states.filter((s) => s === 'urejeno' || s === 'popravljeno' || s === 'ni-urejeno').length;
  const per = value / dutySlots.length;
  return {
    states,
    tidy,
    checked,
    counted,
    earned: Math.round(per * tidy),
    possible: Math.round(per * counted),
  };
}
